$( document ).ready(function() {
  
    var stickyNavTop = $('.site-nav').offset().top + $('.site-nav').outerHeight();
	var actualHeight = $('div[data-section-id="header"]').outerHeight();
	$('.template-collection div[data-section-id="header"]').css('height', actualHeight);
	$(window).scroll(function(){
    if ($(window).scrollTop() >= stickyNavTop) {
        $('.site-nav ').addClass('fixed-header');
        var height = $('.site-nav').outerHeight();
        setTimeout(function() {
          $('.site-nav ').addClass('opening');
        }, 100);
    }
    else {
        $('.site-nav').removeClass('fixed-header');
        $('.site-nav').removeClass('opening');
        setTimeout(function() {
          $('.site-nav').removeClass('opening');
        }, 100);
        //$('.algemene-header + div').css('height', '0px');
    }
});
  
  $('body').on('click', '.btn-request-quote', function(){
    $('.page-container').css('transition', 'initial');
    $('.page-container').css('transform', 'initial');
    
  	$('.modal-quote').addClass('active');
    
  });
  
  $('body').on('click', '.modal-quote-bg, .modal-quote-close', function(){
  	$('.modal-quote').removeClass('active');
	$('.page-container').css("transform","");
    $('.page-container').css("transition","");
  });
  
  
  
  
  
});